import {Input, Modal, Row, Col} from 'antd';
import {useState} from 'react';

export const PhoneNumberEntryModal = ({open, onOk, onClose, props}) => {

    const [phoneNumber, setPhoneNumber] = useState("");
    const [description, setDescription] = useState("");

    const clearInputs = () => {
        setPhoneNumber("");
        setDescription("");
    }
    const handleModalOk = () => {
        if (onOk) {
            onOk({phoneNumber, description});
        }
        clearInputs();
    }

    const handleModalCancel = () => {
        if (onClose) {
            onClose();
        }
        clearInputs();
    }

    const onPhoneNumberChange = (e) => {
        setPhoneNumber(e.target.value);
    }

    const onDescriptionChange = (e) => {
        setDescription(e.target.value);
    }

    return <Modal open={open} title={"New Email Address"} onOk={handleModalOk} onCancel={handleModalCancel}>
        <>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"Phone Number"} onChange={onPhoneNumberChange}/></Col>
            </Row>
            <Row gutter={[16, 22]} style={{paddingTop: '5px', paddingBottom: '5px'}}>
                <Col span={24}><Input placeholder={"Description"} onChange={onDescriptionChange}></Input></Col>
            </Row>
        </>
    </Modal>
}